<template>
  <component
    :is="elementType"
    :class="buttonClass"
    :href="href"
    :target="target"
    :title="title"
    :id="elementId"
    :type="buttonType"
    :disabled="isDisabled"
    :aria-expanded="ariaExpanded"
    @click.stop="onClick"
    :data-cy="dataCy"
  >
    <span class="c-button__inner">
      <span
        class="c-button__label"
        :class="hideLabel ? 'u-visually-hidden' : ''"
        >{{ label }}</span
      >

      <span class="c-button__wrap-icon" v-if="hasIcon">
        <icon :icon="icon" :modifier="iconModifier" />
      </span>
    </span>
  </component>
</template>

<script>
import Icon from '@/components/Utilities/Icon.vue'

export default {
  name: 'ButtonAtom',
  components: {
    icon: Icon,
  },
  props: {
    elementType: {
      type: String,
      default: 'button',
    },
    buttonType: String,
    title: String,
    href: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
    modifier: String,
    isReversed: {
      type: Boolean,
      default: false,
    },
    elementId: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    label: String,
    hideLabel: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    iconModifier: {
      type: String,
      default: '',
    },
    clickCallback: Function,
    ariaExpanded: {
      type: Boolean,
      default: false,
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasIcon() {
      return this.icon !== ''
    },
    buttonClass() {
      var css = 'c-button ' + this.modifier

      if (this.isReversed) {
        css += ' c-button--reversed'
      }

      if (this.hideLabel) {
        css += ' c-button--hide-label'
      }

      if (this.hasIcon) {
        css += ' c-button--has-icon'
      }

      return css
    },
  },
  methods: {
    onClick() {
      if (this.clickCallback) {
        this.clickCallback()
      }
    },
  },
}
</script>
